import gql from "graphql-tag";

export const categoryTranslationFragment = gql`
  fragment CategoryTranslationFragment on Category {
    id
    name
    descriptionJson
    seoDescription
    seoTitle
    seoKeyword
    translation(languageCode: $language) {
      id
      descriptionJson
      language {
        language
      }
      name
      seoDescription
      seoTitle
      seoKeyword
    }
  }
`;
export const collectionTranslationFragment = gql`
  fragment CollectionTranslationFragment on Collection {
    id
    name
    descriptionJson
    seoDescription
    seoTitle
    seoKeyword
    promptText
    promptLink
    popupMessage
    translation(languageCode: $language) {
      id
      descriptionJson
      language {
        language
      }
      name
      seoDescription
      seoTitle
      seoKeyword
      promptText
      promptLink
      popupMessage
    }
  }
`;
export const productTranslationFragment = gql`
  fragment ProductTranslationFragment on Product {
    id
    name
    descriptionJson
    description
    seoDescription
    seoTitle
    seoKeyword
    USP
    care
    metadataJson
    translation(languageCode: $language) {
      id
      descriptionJson
      description
      language {
        code
        language
      }
      name
      seoDescription
      seoTitle
      seoKeyword
      metadata
      USP
      care
    }
  }
`;
export const saleTranslationFragment = gql`
  fragment SaleTranslationFragment on Sale {
    id
    name
    superPriceImage
    superPriceImageMb
    superName
    superPriceText
    translation(languageCode: $language) {
      id
      language {
        code
        language
      }
      superPriceImage
      superPriceImageMb
      superName
      superPriceText
      name
    }
  }
`;
export const voucherTranslationFragment = gql`
  fragment VoucherTranslationFragment on Voucher {
    id
    name
    descriptionText
    descriptionSubtext
    descriptionThirdtext
    translation(languageCode: $language) {
      id
      language {
        code
        language
      }
      descriptionText
      descriptionSubtext
      descriptionThirdtext
      name
    }
  }
`;
export const shippingMethodTranslationFragment = gql`
  fragment ShippingMethodTranslationFragment on ShippingMethod {
    id
    name
    instructions
    translation(languageCode: $language) {
      id
      language {
        code
        language
      }
      name
      instructions
    }
  }
`;
export const pageTranslationFragment = gql`
  fragment PageTranslationFragment on Page {
    id
    contentJson
    seoDescription
    seoTitle
    seoKeyword
    title
    metadataJson
    translation(languageCode: $language) {
      id
      contentJson
      seoDescription
      seoTitle
      seoKeyword
      title
      metadata
      language {
        code
        language
      }
    }
  }
`;
export const pageTranslatableFragment = gql`
  fragment PageTranslatableFragment on Page {
    id
    contentJson
    seoDescription
    seoTitle
    seoKeyword
    title

    translation(languageCode: $language) {
      id
      contentJson
      seoDescription
      seoTitle
      seoKeyword
      title
      language {
        code
        language
      }
    }
  }
`;
export const productTypeTranslationFragment = gql`
  fragment AttributeTranslationFragment on Attribute {
    id
    showName
    name
    translation(languageCode: $language) {
      id
      name
      showName
    }
    values {
      id
      name
      translation(languageCode: $language) {
        id
        name
      }
    }
  }
  fragment ProductTypeTranslationFragment on ProductType {
    id
    name
    productAttributes {
      ...AttributeTranslationFragment
    }
    variantAttributes {
      ...AttributeTranslationFragment
    }
    skuAttributes {
      ...AttributeTranslationFragment
    }
    translation(languageCode: $language) {
      id
      name
    }
  }
`;

export const shopTranslationFragment = gql`
  fragment ShopTranslationFragment on ShopSettings {
    id
    title
    headerText
    keywords
    description

    translation(languageCode: $language) {
      id
      title
      headerText
      keywords
      description
      language {
        code
        language
      }
    }
  }
`;

export const extrachargeTranslationFragment = gql`
  fragment ExtraChargeTranslationFragment on ExtraCharge {
    id
    code
    name
    desc
    subName
    subDesc

    translation(languageCode: $language) {
      id
      name
      desc
      subName
      subDesc
      language {
        code
        language
      }
    }
  }
`;
export const menuItemTranslatableFragment = gql`
  fragment MenuItemTranslatableFragment on MenuItem {
    id
    name
    url
    thumbnailUrl
    translation(languageCode: $language) {
      id
      name
      url
      thumbnailUrl
      language {
        code
        language
      }
    }
  }
`;
export const productTagsTranslatableFragment = gql`
  fragment ProductTagsTranslationFragment on ProductTags {
    id
    name
    translation(languageCode: $language) {
      id
      name
      language {
        code
        language
      }
    }
  }
`;

export const menuItemTranslationFragment = gql`
  fragment MenuItemTranslationFragment on MenuItem {
    id
    name
    url
    thumbnailUrl
    mbThumbnailUrl
    translation(languageCode: $language) {
      id
      name
      url
      thumbnailUrl
      mbThumbnailUrl
      language {
        code
        language
      }
    }
  }
`;

export const productTagsTranslationFragment = gql`
  fragment ProductTagsTranslationFragment on ProductTags {
    id
    name
    translation(languageCode: $language) {
      id
      name
      language {
        code
        language
      }
    }
  }
`;

export const hotSearchTranslationFragment = gql`
  fragment HotSearchTranslationFragment on Hotworld {
    id
    hotWord
    translation(languageCode: $language) {
      id
      hotWord
      language {
        code
        language
      }
    }
  }
`;

export const cornerMarkTranslationFragment = gql`
  fragment CornerMarkTranslationFragment on CornerMark {
    id
    titleText
    translation(languageCode: $language) {
      id
      title
      language {
        code
        language
      }
    }
  }
`;

export const productVariantTranslationFragment = gql`
  fragment ProductVariantTranslationFragment on ProductVariant {
    id
    name
    skuName
    fullDescription
    shortDescription
    describe
    USP
    seoTitle
    seoKeyword
    seoDescription
    metadataJson
    product {
      name
    }
    translation(languageCode: $language) {
      id
      name
      skuName
      fullDescription
      shortDescription
      describe
      USP
      seoTitle
      seoKeyword
      metadata
      seoDescription
      language {
        code
        language
      }
    }
  }
`;

export const pageHeaderTranslationFragment = gql`
  fragment PageHeaderTranslationFragment on PageHeader {
    id
    name
    pcContent
    mobileContent
    translation(languageCode: $language) {
      id
      name
      pcContent
      mobileContent
      language {
        code
        language
      }
    }
  }
`;

export const pageHeaderTranslatableFragment = gql`
  fragment PageHeaderTranslatableFragment on PageHeader {
    id
    name
    pcContent
    mobileContent
    translation(languageCode: $language) {
      id
      name
      pcContent
      mobileContent
      language {
        code
        language
      }
    }
  }
`;

export const menuBannerTranslatableFragment = gql`
  fragment MenuBannerTranslatableFragment on MenuBanner {
    id
    title
    subtitle
    url
    pcImageUrl
    h5ImageUrl
    translation(languageCode: $language) {
      id
      title
      subtitle
      url
      pcImageUrl
      h5ImageUrl
      language {
        code
        language
      }
    }
  }
`;

export const menuBannerTranslationFragment = gql`
  fragment MenuBannerTranslationFragment on MenuBanner {
    id
    title
    subtitle
    url
    pcImageUrl
    h5ImageUrl
    translation(languageCode: $language) {
      id
      title
      subtitle
      url
      pcImageUrl
      h5ImageUrl
      language {
        code
        language
      }
    }
  }
`;

export const comboTranslationFragment = gql`
  fragment ComboTranslationFragment on Combo {
    id
    name
    labelText
    labelLink
    translation(languageCode: $language) {
      id
      name
      labelText
      labelLink
      language {
        code
        language
      }
    }
  }
`;

export const loginPopupTranslationFragment = gql`
  fragment LoginPopupTranslationFragment on LoginPopup {
    id
    title
    coupon
    Button
    pcUrl
    mbUrl
    couponCode
    couponText
    buttonText
    subTitle
    translation(languageCode: $language) {
      id
      title
      coupon
      Button
      pcUrl
      mbUrl
      couponCode
      couponText
      buttonText
      subTitle
      language {
        code
        language
      }
    }
  }
`;

export const productActivationSettingTranslationFragment = gql`
  fragment ProductActivationSettingTranslationFragment on ProductActivationSetting {
    id
    activationPcTitle
    activationPcContent
    activationPcSuccessedTitle
    activationPcSuccessedContent
    activationMbTitle
    activationMbContent
    activationMbSuccessedTitle
    activationMbSuccessedContent
    serialNumberPcContent
    serialNumberMbContent
    translation(languageCode: $language) {
      id
      activationPcTitle
      activationPcContent
      activationPcSuccessedTitle
      activationPcSuccessedContent
      activationMbTitle
      activationMbContent
      activationMbSuccessedTitle
      activationMbSuccessedContent
      serialNumberPcContent
      serialNumberMbContent
      language {
        code
        language
      }
    }
  }
`;

export const productLensTypeTranslationFragment = gql`
  fragment ProductLensTypeTranslationFragment on ProductLensType {
    id
    name
    translation(languageCode: $language) {
      id
      name
      language {
        code
        language
      }
    }
  }
`;
